module.exports = __webpack_public_path__ + "img/home_point.1e526f7f.png";